<div class="center">
    <iui-messages #message  class="ms-auto me-auto"></iui-messages>
</div>
<div class="banner">
    <div class="col-12">
        <h1>Registry Reports</h1>
    </div>
</div>
<div class="tabcontent">
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-5">
                    <h5>Leased Short Codes Report</h5>
                    <p>
                        Includes all short codes in the Short Code Registry that are currently leased, as well as those 
                        that are expired but have not been released into the available pool. 
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <p>
                        <b>Leased Short Codes</b> {{registryReportData.carrier?.lastRunDate}}
                    </p>
                </div>
                <div class="offset-md-3 col-6">
                    <button class="btn btn-primary w-75"
                        (click)="downloadReport(registryReportData.carrier?.downloadUrl)">Download
                        Leased Short Codes Report</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <div class="row">
                <div class="col-5">
                    <h5>Weekly Carrier Report</h5>
                    <p>
                        Includes deactivations (short codes that expired), re-activations, new short codes, and short
                        code
                        updates that occurred during the last week. The report is updated weekly.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <p>
                        <b>Weekly Carrier Report</b> {{registryReportData.carrierWeekly?.lastRunDate}}
                    </p>
                </div>
                <div class="offset-md-3 col-6">
                    <button class="btn btn-primary w-75"
                        (click)="downloadReport(registryReportData.carrierWeekly?.downloadUrl)">Download
                        Weekly Carrier Report</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <div class="row">
                <div class="col-5">
                    <h5>Aged Short Codes Report</h5>
                    <p>
                        Short codes that have expired, aged out and returned to the available pool during the specified
                        date range.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <p-dropdown appDd [(ngModel)]="agedReportDateChoice" [filter]="true" id="agedReportDateChoice"
                        name="agedReportDateChoice" placeholder="agedReportDateChoice" [options]="agedReportDateChoices"
                        optionLabel="label" optionValue="value">
                    </p-dropdown>
                </div>
                <div class="offset-md-3 col-6">
                    <button class="btn btn-primary w-75" (click)="getAgedReport()">Download
                        Aged Short Codes Report</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <div class="row">
                <div class="col-5">
                    <h5>Short Code Transfer Report</h5>
                    <p>
                        Short code transfers that occurred between organizations during the specified date range.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <p-dropdown appDd [(ngModel)]="dateChoice" [filter]="true" id="dateChoice" name="dateChoice"
                        (ngModelChange)="onChangeSelection()" placeholder="dateChoice" [options]="dateChoices"
                        optionLabel="label" optionValue="value">
                    </p-dropdown>
                </div>
                <div class="offset-md-3 col-6">
                    <button class="btn btn-primary w-75" (click)="dateRangeTransfer()">Download
                        Short Code Transfer Report</button>
                </div>
            </div>
            <div *ngIf="dateChoice === 'DateRange'" class="row mt-1">
                <div class="col-md-3">
                    <label for="startDate">Start</label>
                    <div>
                        <p-calendar placeholder="Start Date" [maxDate]="today" [showIcon]="true" inputId="startDate"
                            name="startDate" [(ngModel)]="transferReportRequest.startDate" dateFormat="yy-mm-dd"
                            (ngModelChange)="clearEndDate()">
                        </p-calendar>
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="endDate">End </label>
                    <div>
                        <p-calendar placeholder="End Date" [showIcon]="true" inputId="endDate" name="endDate"
                            [(ngModel)]="transferReportRequest.endDate" dateFormat="yy-mm-dd"
                            [minDate]="transferReportRequest.startDate" [disabled]="!transferReportRequest.startDate">
                        </p-calendar>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <div class="row">
                <div class="col-5">
                    <h5>Legacy Approved Reports</h5>
                    <p>
                        Short Code Leases that are currently approved in the Short Code Registry. The report is produced
                        in a legacy format and updated daily.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <p>
                        <b>Approved Short Codes</b> {{registryReportData.approved?.lastRunDate}}
                    </p>
                </div>
                <div class="offset-md-3 col-6">
                    <button class="btn btn-primary w-75"
                        (click)="downloadReport(registryReportData.approved?.downloadUrl)">Download Approved Short Codes
                        Report</button>
                </div>
            </div>
        </div>
    </div>
</div>